import { render } from "./MSelect.vue?vue&type=template&id=76923bf1&ts=true"
import script from "./MSelect.vue?vue&type=script&lang=ts"
export * from "./MSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__